import React, { useState, useEffect } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Card,
  Button,
} from "@mui/material";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import apiService from "../../utils/apiservice";

const API_URL = process.env.REACT_APP_API_DJANGO_URL;

const EngineerSites = () => {
  const [rows, setRows] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    const userId = localStorage.getItem("userId");
    if (userId) fetchSupervisorSites(userId);
  }, []);

  const fetchSupervisorSites = async (userId) => {
    try {
      const token = localStorage.getItem("accessToken");
      // const response = await axios.get(
      //   `${API_URL}/api/engineer_sites/${userId}/`,
      //   {
      //     headers: {
      //       Authorization: `Bearer ${token}`,
      //       Accept: "application/json",
      //     },
      //     data:{},
      //   }
      // );

      const response = await apiService.get(
  `/api/engineer_sites/${userId}/`,
  { data: {} } // optional
);
const formattedData = response.data.sites.map((site, index) => ({
  id: index + 1,
  site_id: site.site_id,
  name: site.site_name,
  asset_id: site.asset_id,
  address: site.address,
  latitude: site.latitude,
  longitude: site.longitude,
  assigned_at: site.assigned_at,
  supervisor_name: response.data.reports_to, 
  assigned_by: site.assigned_by_role, // ✅ ADD THIS
}));
      setRows(formattedData);
    } catch (error) {
      console.error("Error fetching supervisor sites:", error);
      const msg =
        error.response?.data?.error || "Failed to fetch supervisor sites.";
      toast.error(msg);
    }
  };

  return (
    <Box sx={{ maxWidth: 1500, mx: "auto", py: 4, px: 2 }}>
      <Typography
        variant="h5"
        sx={{
          mb: 4,
          fontWeight: "bold",
          textAlign: "left",
          borderBottom: "2px solid #1976d2",
          display: "inline-block",
        }}
      >
        Engineers Sites
      </Typography>

      <Card
        sx={{
          p: 2,
          borderRadius: 3,
          boxShadow: 4,
          background: "linear-gradient(135deg, #bdbdbd 10%, #f8fafd 80%)",
        }}
      >
        <ToastContainer position="top-right" autoClose={3000} />

        <TableContainer
  component={Paper}
  elevation={6}
  sx={{
    borderRadius: 3,
    overflowY: "auto",
    overflowX: "auto",
    maxHeight: 400, // adjust height as needed
    background: "transparent",

    // optional scrollbar styling
    "&::-webkit-scrollbar": {
      width: "8px",
      height: "8px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#cbd5e1",
      borderRadius: "10px",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#f1f5f9",
    },
  }}
>
          <Table stickyHeader
  sx={{
    "& .MuiTableCell-root": {
      fontSize: 13,
      color: "#1e293b",
      borderBottom: "1px solid #e2e8f0",
    },
    "& .MuiTableCell-head": {
      fontWeight: "bold",
      backgroundColor: "#eef2f7",
      color: "#0f172a",
    },
  }}
>
           <TableHead>
  <TableRow>
    {["Sr No", "Site Name", "Address", "Latitude", "Longitude", "Assigned By", "Assigned At"].map((text) => (
      <TableCell
        key={text}
        sx={{
          background:
            "linear-gradient(to bottom, #EE7F1A 0%, #f2b14b 55%, #eea53a 100%)",
          color: "#fff",
          fontWeight: "bold",
        }}
      >
        {text}
      </TableCell>
    ))}
  </TableRow>
</TableHead>
            <TableBody>
              {rows
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => (
                  <TableRow
                    key={row.id}
                    sx={{
                      "&:hover": { backgroundColor: "#f8fafc" },
                    }}
                  >
                    <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                    <TableCell>{row.name}</TableCell>
                  
                    <TableCell>{row.address}</TableCell>
                    <TableCell>{row.latitude}</TableCell>
                    <TableCell>{row.longitude}</TableCell>
                    <TableCell>{row.assigned_by}</TableCell>
                    <TableCell>
                      {new Date(row.assigned_at).toLocaleString()}
                    </TableCell>
                    {/* <TableCell>{row.supervisor_name}</TableCell> */}
                  </TableRow>
                ))}
            </TableBody>
          </Table>

         
        </TableContainer>
         {/* Custom Pagination */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              padding: "15px",
              gap: "20px",
              fontSize: 13,
              color: "#64748b",
              borderTop: "1px solid #e2e8f0",
background: "#f8fafc",
            }}
          >
           

            <Box sx={{ fontWeight: 500, minWidth: 80, textAlign: "center" }}>
              {rows.length > 0 ? page * rowsPerPage + 1 : 0}-
              {Math.min((page + 1) * rowsPerPage, rows.length)} of {rows.length}
            </Box>

            <Box sx={{ display: "flex", gap: 1 }}>
              <Button
                onClick={() => setPage(page - 1)}
                disabled={page === 0}
                sx={{
                  fontSize: 22,
                  minWidth: "auto",
                  color: page === 0 ? "#e2e8f0" : "#94a3b8",
                  padding: "0 5px",
                  "&:hover": { color: "#1e293b", transform: "scale(1.1)" },
                }}
              >
                ‹
              </Button>
              <Button
                onClick={() => setPage(page + 1)}
                disabled={(page + 1) * rowsPerPage >= rows.length}
                sx={{
                  fontSize: 22,
                  minWidth: "auto",
                  color:
                    (page + 1) * rowsPerPage >= rows.length
                      ? "#e2e8f0"
                      : "#94a3b8",
                  padding: "0 5px",
                  "&:hover": { color: "#1e293b", transform: "scale(1.1)" },
                }}
              >
                ›
              </Button>
            </Box>
          </Box>
        
      </Card>
    </Box>
  );
};

export default EngineerSites;